import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}/administracao`

export default {
    obterPerguntas(id) {
        let url = `${api}/pesquisas/${id}/perguntas`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterRespostas(tipo) {
        let url = `${api}/pesquisas/respostas?tipo=${tipo}`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterResposta(respostaId) {
        let url = `${api}/pesquisas/respostas/${respostaId}`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    enviar(respostas) {
        let url = `${api}/pesquisas/responder`
        return axiosJwt
            .post(url, respostas)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
